module.exports = "//static.hsappstatic.net/connect-dot-com-ui/static-1.384/img/directory-opengraph.png"